// Shared form-control contract. Pairs with styles/base/_iosSafeInput.scss —
// the 16px floor that stops iOS Safari zooming on focus lives in CSS ONLY.
// Nothing here sets a font-size: an inline style would beat the stylesheet on
// every platform, so desktop and Android would change too.

/** Applies the iOS 16px floor (styles/base/_iosSafeInput.scss, layer 1). */
export const IOS_SAFE_INPUT_CLASS = 'ios-safe-input'

/** Trims side padding for narrow fields once the glyphs grow to 16px. */
export const IOS_SAFE_INPUT_COMPACT_CLASS = 'ios-safe-input--compact'

/**
 * Attributes shared by every numeric field in the app.
 *
 * `type="text"` + `inputMode="decimal"` is deliberate: it opens the decimal
 * keypad on iOS and Android while avoiding `type="number"`'s spinners,
 * scroll-wheel mutation and locale-dependent parsing. It also matches what the
 * betting cards already declared, so the keyboard is unchanged.
 *
 * There is deliberately NO `pattern="[0-9]*"`: that was the pre-inputMode
 * keypad hack, and on a decimal field it marks any value containing "." as
 * :invalid. (Nothing in this repo selects on :valid/:invalid — the floating
 * stake label is driven by the `.filled` class plus :focus — but adding a
 * pattern would still flip native validity for no benefit.)
 */
export const DECIMAL_INPUT_PROPS = {
  type: 'text',
  inputMode: 'decimal',
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: false,
}
